import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import './ScheduleCreationSuccessModel.css';

// Success component to show after successful scheduling
const ScheduleCreationSuccessModel = ({ sessionType }) => {
  return (
    <Box className="success-message-container">
      <Box className="success-icon-container">
        <CheckCircleOutlineIcon className="success-icon" />
      </Box>
      <Typography className="success-title">{sessionType} Session Created Successfully!</Typography>
      <Typography className="success-description">
        Your {sessionType.toLowerCase()} session has been created and is now visible in your
        schedule. Students can now book this session.
      </Typography>
    </Box>
  );
};

export default ScheduleCreationSuccessModel;
